/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { Spacing } from '@zapier/theme';

import InputWithLabel from './InputWithLabel';
import { sectionStyle } from './constants';

const Styles = {
  root: css`
    @media screen and (min-width: 768px) : {
      flex-direction: row;
    }
  `,
  inputWrapperStyle: css`
    margin-top: 20px;

    &:first-of-type {
      margin-top: ${Spacing.none};
    }

    @media screen and (min-width: 768px) {
      max-width: 290px;
      width: 100%;
    }
  `,
};

type Props = {
  firstName: string;
  lastName: string;
  onChangeFirstName: (firstNameNext: string) => void;
  onChangeLastName: (lastNameNext: string) => void;
};

function SectionName({
  lastName,
  firstName,
  onChangeFirstName,
  onChangeLastName,
}: Props) {
  return (
    <div css={[Styles.root, sectionStyle]}>
      <div css={Styles.inputWrapperStyle}>
        <InputWithLabel
          aria-describedby="first-name"
          aria-label="Subscriber first name"
          aria-required={true}
          errorMessage="Required."
          id="first-name"
          name="first-name"
          onChange={onChangeFirstName}
          title="First Name"
          value={firstName}
        />
      </div>
      <div css={Styles.inputWrapperStyle}>
        <InputWithLabel
          aria-describedby="last-name"
          aria-label="Subscriber last name"
          aria-required={true}
          errorMessage="Required."
          id="last-name"
          name="last-name"
          onChange={onChangeLastName}
          title="Last Name"
          value={lastName}
        />
      </div>
    </div>
  );
}

export default SectionName;
